import React from "react";
import { Card, Grid } from "@mui/material";
import CardBody from "../../../components/Card/CardBody";

function Tablet() {
  return (
    <Card>
      <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
        <Grid container spacing={1} />
      </CardBody>
    </Card>
  );
}

export default Tablet;
